(function initProductAutoplay(){
  const STARTED_FLAG = 'data-autoplay-initialized';
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  const showFor1s = (video) => {
    let t;
    const show = () => {
      video.controls = true;
      clearTimeout(t);
      t = setTimeout(() => { video.controls = false; }, 1000);
    };
    video.addEventListener('play', show, { passive: true });
    ['click','touchstart'].forEach(e => video.addEventListener(e, show, { passive: true }));
    video.addEventListener('pause', () => { video.controls = true; }, { passive: true });
    video.addEventListener('ended', () => { video.controls = true; }, { passive: true });
    // show briefly on first play
    show();
  };

  const prepVideo = (v) => {
    v.muted = true;
    v.playsInline = true;
    v.setAttribute('muted','');
    v.setAttribute('playsinline','');
    v.setAttribute('webkit-playsinline','');
    v.setAttribute('preload','metadata');
    if (!v.hasAttribute('loop')) v.loop = true;
    v.controls = false;
  };

  const markPlaying = (el, isPlaying) => {
    const wrapper = el.closest('deferred-media, .deferred-media') || el.parentElement;
    if (!wrapper) return;
    wrapper.classList.toggle('autoplay-active', !!isPlaying);
  };

  const loadDeferredVideo = (wrapper) => {
    if (!wrapper || wrapper.hasAttribute(STARTED_FLAG)) return wrapper.querySelector('video');
    const tpl = wrapper.querySelector('template');
    if (!tpl || !tpl.content) return null;
    if (tpl.content.querySelector('iframe')) return null; // skip external embeds
    const frag = tpl.content.cloneNode(true);
    wrapper.appendChild(frag);
    wrapper.setAttribute(STARTED_FLAG, 'true');
    const vid = wrapper.querySelector('video');
    if (vid) prepVideo(vid);
    return vid || null;
  };

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // If target is a video
      if (entry.target.tagName?.toLowerCase() === 'video') {
        const vid = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          prepVideo(vid);
          vid.play().then(() => {
            showFor1s(vid);
            markPlaying(vid, true);
          }).catch(()=>{});
        } else {
          vid.pause();
          markPlaying(vid, false);
        }
        return;
      }
      // If target is a <deferred-media> wrapper
      const wrapper = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
        let vid = wrapper.querySelector('video') || loadDeferredVideo(wrapper);
        if (vid) {
          prepVideo(vid);
          vid.play().then(() => {
            showFor1s(vid);
            markPlaying(vid, true);
          }).catch(()=>{});
        }
      } else {
        const vid = wrapper.querySelector('video');
        if (vid) vid.pause();
        markPlaying(wrapper, false);
      }
    });
  }, { threshold: [0, 0.5, 1] });

  // Observe initial nodes
  document.querySelectorAll('video').forEach(v => io.observe(v));
  document.querySelectorAll('deferred-media, .deferred-media').forEach(el => io.observe(el));

  // Re-init on section reloads
  const onReload = () => { io.disconnect(); initProductAutoplay(); };
  document.addEventListener('shopify:section:load', onReload, { once: true });
  document.addEventListener('shopify:section:unload', onReload, { once: true });
})();
